(function organizationalUnitDetailControllerDefinition() {
    'use strict';

    angular.module('OrganizationalUnit')
        .controller('OrganizationalUnitDetailController', [
            '$scope', 'config', '$state', '$translate', '$stateParams', 'errorsExtend', 'adminOrganizationalUnitService', 'authExtend', 'organizartionalUnitAction', '$filter',
            function organizationalUnitDetailController($scope, config, $state, $translate, $stateParams, errors, adminOrganizationalUnitService, authExtend, organizartionalUnitAction, $filter) {
                $scope.ouSecurityDescription = [];
                $scope.viewAudit = authExtend.isInRole('AUDIT READ');
                $scope.logo = null;
                $scope.startImage = null;
                // Esta función realiza un merge del nombre y el valor de los metadatos para mostrarlos.
                var mergeMetadataAndValues = function (ou) {
                    if (ou.securityLevelConfig.description) {
                        $scope.ouSecurityDescription = ou.securityLevelConfig.description.split('.');
                    }

                    angular.forEach(ou.configs, function (ouOuConfig) {

                        // armo un diccionario con los valores que tiene el usuario para sus metadatos
                        var metadataValues = {};

                        angular.forEach(ouOuConfig.metadataValues, function (ouOuConfigMetadataValue) {
                            metadataValues[ouOuConfigMetadataValue.organizationalUnitConfigMetadata.id] = ouOuConfigMetadataValue;
                        });

                        ouOuConfig.metadataValues = ouOuConfig.organizationalUnitConfig.metadata.map(function (ouConfigMetadata) {

                            var val = metadataValues[ouConfigMetadata.id] ? metadataValues[ouConfigMetadata.id].value : '';

                            if (ouConfigMetadata.metadata.metadataType.name === 'Combo') {
                                var property = ouConfigMetadata.metadata.properties.find(function (prop) {
                                    return prop.property.name === 'options';
                                });

                                if (property) {
                                    var itm = JSON.parse(property.value).find(function (v) {
                                        return v.value === val;
                                    });

                                    if (itm) {
                                        val = itm.desc || itm.value;
                                    }
                                }
                            }

                            return {
                                name: ouConfigMetadata.metadata.name,
                                position: ouConfigMetadata.position,
                                value: val
                            };
                        });

                        ouOuConfig.metadataValues.sort(function (a, b) {
                            return a.position - b.position;
                        });

                    });

                };

                $scope.modifyBtn = authExtend.isInRole('ORGANIZATIONALUNIT WRITE');
                $scope.enableDisableBtn = authExtend.isInRole('ORGANIZATIONALUNIT ENABLED DISABLED');
                $scope.enableviewIndex = authExtend.isInRole('VIEW INDEX') || authExtend.isInRole('EDIT AND DELETE INDEX');
                $scope.options = {
                    toggleWrap: function (scope) {
                        var collapsed = scope.$nodeScope.collapsed = !scope.$nodeScope.collapsed;
                        if (!collapsed & !scope.hasChild()) {
                            adminOrganizationalUnitService.getTreeOf(scope.$nodeScope.$modelValue.id).then(function (result) {
                                if (result.length > 0) {
                                    scope.$nodeScope.$modelValue.childs = result[0].childs;
                                }
                            });
                        }
                    }
                };

                adminOrganizationalUnitService.getById($stateParams.id, false).then(function (result) {
                    if (result) {

                        mergeMetadataAndValues(result);

                        $scope.ou = result;
                    } else {
                        errors.showError('NotFound');
                        $state.go('organizational-unit-find');
                    }
                }, function (error) {
                    errors.showError(error);
                    $state.go('organizational-unit-find');
                });

                if ($stateParams.id) {
                    adminOrganizationalUnitService.getImagesById($stateParams.id).then(function (result) {
                        if (result) {
                            var filteredLogo = $filter('filter')(result, { isLogo: true }, true)[0];
                            $scope.logo = filteredLogo !== undefined ? 'data:image/jpeg;base64,' + filteredLogo.base64File : undefined;

                            var filteredStartImage = $filter('filter')(result, { isLogo: false }, true)[0];
                            $scope.startImage = filteredStartImage !== undefined ? 'data:image/jpeg;base64,' + filteredStartImage.base64File : undefined;

                        } else {
                            errors.showError('NotFound');
                            $state.go('organizational-unit-find');
                        }
                    }, function (error) {
                        errors.showError(error);
                        $state.go('organizational-unit-find');
                    });
                }

                $scope.cancel = function () {
                    $state.go('organizational-unit-find');
                };

                $scope.modify = function () {
                    $state.go('organizational-unit-modify', { id: $scope.ou.id });
                };

                $scope.enable = function () {
                    return organizartionalUnitAction.enable($scope.ou).then(function getOk() {
                        $scope.ou.enabled = true;
                    });
                };

                $scope.disable = function () {
                    return organizartionalUnitAction.disable($scope.ou)
                        .then(function getOk() {
                            $scope.ou.enabled = false;
                        });
                };

                $scope.viewIndex = function () {
                    $state.go('dba-detail', { key: 'OU', id: $scope.ou.id });
                };
                $scope.viewAuditHistory = function () {
                    var params = [];
                    params.push($scope.ou.id);
                    $state.go('audit-history', {
                        entityName: "OU",
                        entityValues: params,
                        displayName: $scope.ou.name,
                        organizationalUnitId: $scope.ou.id
                    });
                };
            }
        ]);
})();
